import axios from "../axios";

const api = {
  getAll(queryParams, accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires?${queryParams}`, config).then(({ data }) => data);
  },

  create(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/supplier-questionnaires", data, headers).then(({ data }) => data);
  },

  bulkCreate(data, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post("/supplier-questionnaires/all", data, headers).then(({ data }) => data);
  },

  delete(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.delete(`/supplier-questionnaires/${id}`, headers).then(({ data }) => data);
  },

  update({ id, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.put(`/supplier-questionnaires/${id}`, data, headers).then(({ data }) => data);
  },

  getOwnedSupplierQuestionnaires(paramsString, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/supplier-questionnaires-data/supplier/owned${paramsString}`, headers).then(({ data }) => data);
  },

  finalizeQuestionnaire(id, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${id}/finalize`, {}, headers).then(({ data }) => data);
  },

  getSupplierQuestionnaireById(id, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/supplier-questionnaires-data/${id}`, headers).then(({ data }) => data);
  },

  getSupplierQuestionnairesSummary(queryParams, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get(`/supplier-questionnaires/summary?${queryParams}`, headers).then(({ data }) => data);
  },

  getSupplierQuestionnaireStructure(accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get("/supplier-questionnaires/structure", headers).then(({ data }) => data);
  },

  setQuestionnaireCategory({ id, category }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}`, 'Content-Type': 'application/json', } };
    return axios.patch(`/supplier-questionnaires-data/${id}/category`, category, headers).then(({ data }) => data);
  },

  getScopeOneConsumptionTypes(accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get("/supplier-questionnaires/consumption-types/scope-one", headers).then(({ data }) => data);
  },

  getScopeTwoConsumptionTypes(accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.get("/supplier-questionnaires/consumption-types/scope-two", headers).then(({ data }) => data);
  },

  unfinaliseSupplierQuestionnaire({ questionnaireId, type }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`/supplier-questionnaires/${questionnaireId}/unfinalize?type=${type}`, {}, headers).then(({ data }) => data);
  },

  updateFinancialYearEndMonth({ questionnaireId, body }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.patch(`/supplier-questionnaires-data/${questionnaireId}/financial-year-end-month`,
      body, headers).then(({ data }) => data);
  },

  revertQuestionnaireCategory({ id, category }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}`, 'Content-Type': 'application/json', } };
    return axios.patch(`/supplier-questionnaires-data/${id}/revert`, category, headers).then(({ data }) => data);
  },
};

export default api;